var _LottieParser_raw, _LottieParser_startWidth, _LottieParser_startHeight;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class LottieParser {
    constructor(json) {
        _LottieParser_raw.set(this, void 0);
        _LottieParser_startWidth.set(this, void 0);
        _LottieParser_startHeight.set(this, void 0);
        __classPrivateFieldSet(this, _LottieParser_raw, json, "f");
        __classPrivateFieldSet(this, _LottieParser_startWidth, json.w, "f");
        __classPrivateFieldSet(this, _LottieParser_startHeight, json.h, "f");
    }
    get json() {
        return __classPrivateFieldGet(this, _LottieParser_raw, "f");
    }
    async setSize(width, height) {
        var _a, _b;
        __classPrivateFieldGet(this, _LottieParser_raw, "f").w = width;
        __classPrivateFieldGet(this, _LottieParser_raw, "f").h = height;
        for (const layer of __classPrivateFieldGet(this, _LottieParser_raw, "f").layers) {
            if ((_a = layer.ks.p) === null || _a === void 0 ? void 0 : _a.k)
                layer.ks.p.k = [width / 2, height / 2, 0.0];
            if ((_b = layer.ks.s) === null || _b === void 0 ? void 0 : _b.k)
                layer.ks.s.k = [(width / __classPrivateFieldGet(this, _LottieParser_startWidth, "f")) * 100, (height / __classPrivateFieldGet(this, _LottieParser_startHeight, "f")) * 100, 100];
        }
    }
}
_LottieParser_raw = new WeakMap(), _LottieParser_startWidth = new WeakMap(), _LottieParser_startHeight = new WeakMap();
